import React, { useState, useMemo, Suspense } from 'react';
import { Spinner } from 'react-bootstrap';
import Layout from "./components/Layout";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AdminHome from './pages/AdminHome';
import Login from './pages/Login';
import UserActivation from './pages/UserActivation';
import UserResetPwd from './pages/UserResetPwd';
import NewPwd from './pages/NewPwd';
import NewPwdSecQnA from './pages/NewPwdSecQnA';
import { UserContext } from "./UserContext";
import { UIContext } from "./UIContext";
import { WSContext } from "./WSContext";
import { AxoisUtilComponent } from "./utils/AxoisUtilComponent";
import ProtectedRoute from './ProtectedRoute';
import { Navigate } from 'react-router-dom';


function App() {
  const [user, setUser] = useState(null);
  const [ui,   setUI] = useState({fullStreen: false});
  const [ws,   setWS] = useState({socket: null});

  const userContextValue = useMemo(() => ({ user, setUser }), [user, setUser]);
  const uiContextValue = useMemo(() => ({ ui, setUI }), [ui, setUI]);
  const wsContextValue = useMemo(() => ({ ws, setWS }), [ws, setWS]);

  const handleLogin = (userData) => {
    sessionStorage.setItem("accessToken", userData.accessToken);
  }

  const handleLogout = () => {
    sessionStorage.setItem("accessToken", '');
  }
  
  const userActivationHandler = () => {
    // ###
  }

  const userResetPwdHandler = () => {
    // ###
  }


  return (
    <Suspense fallback={<Spinner />}>
      <BrowserRouter>
        <UIContext.Provider value={uiContextValue}>
          <UserContext.Provider value={userContextValue}>
            <WSContext.Provider value={wsContextValue}>
              <AxoisUtilComponent>
                <Routes>

                  <Route path="/" element={<Layout logoutHandler={handleLogout} />}>
                    <Route path="/" element={<Navigate to="/AdminHome" />} />
                    <Route path="Login/:lng" element={<Login loginHandler={handleLogin} />}></Route>
                    <Route path="UserActivation/" element={<UserActivation userActivationHandler={userActivationHandler} />}></Route>
                    <Route path="UserResetPwd/" element={<UserResetPwd userResetPwdHandler={userResetPwdHandler} />}></Route>
                    <Route path="NewPwd/:username" element={<NewPwd />}></Route>
                    <Route path="NewPwdSecQnA/:username" element={<NewPwdSecQnA />}></Route>
                    <Route
                      path="/AdminHome/*"
                      element={
                        <ProtectedRoute>
                          <AdminHome />
                        </ProtectedRoute>
                      }
                    />
                  </Route>

                </Routes>
              </AxoisUtilComponent>
            </WSContext.Provider>
          </UserContext.Provider>
        </UIContext.Provider>
      </BrowserRouter>
    </Suspense>
  );
}

export default App;
